import { inject, Injectable } from '@angular/core';
import { NonNullableFormBuilder, Validators } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import { LocationFormGroup, LocationFormMode, TimeZonesEnum } from '@ep/shared';
import { Location } from '@shared/models';

@Injectable()
export class LocationFormService {
  private readonly fb = inject(NonNullableFormBuilder);

  private readonly mode$$ = new BehaviorSubject<LocationFormMode>('add');
  readonly mode$ = this.mode$$.asObservable();

  private readonly locationForm: LocationFormGroup = this.fb.group({
    Name: this.fb.control<string | null>(null, { validators: [Validators.required] }),
    Address: this.fb.control<string | null>(null, { validators: [Validators.required] }),
    PhoneNumber: this.fb.control<string | null>(null, { validators: [Validators.required] }),
    TimeZoneType: this.fb.control<TimeZonesEnum | null>(TimeZonesEnum.PACIFICTIME, {
      validators: [Validators.required],
    }),
  });

  getForm(): LocationFormGroup {
    return this.locationForm;
  }

  getMode(): LocationFormMode {
    return this.mode$$.value;
  }

  initializeForAdd(): void {
    this.mode$$.next('add');
    this.resetTo(null);
    this.locationForm.enable();
  }

  initializeForView(location: Location): void {
    this.mode$$.next('view');
    this.resetTo(location);
    this.locationForm.disable();
  }

  initializeForEdit(location: Location): void {
    this.mode$$.next('edit');
    this.resetTo(location);
    this.locationForm.enable();
  }

  private resetTo(location: Location | null): void {
    this.locationForm.reset({
      Name: location?.Name ?? null,
      Address: location?.Address ?? null,
      PhoneNumber: location?.PhoneNumber ?? null,
      TimeZoneType: location?.TimeZoneType ?? TimeZonesEnum.PACIFICTIME,
    });
  }
}
